import { setup } from 'xstate5'

export const PmDefaultViewsPureState = setup({
  types: {
    meta: {} as {
      error?: boolean
      errorMessage?: string
    },
  },
}).createMachine({
  id: 'PmDefaultViewsPureState',
  initial: 'default',

  context: {
    error: undefined,
    errorDetails: undefined,
  },

  states: {
    default: {},
    saving: {},
    success: {},
    error: {
      meta: {
        error: true,
        errorMessage:
          'Es gab einen unbekannten Fehler beim Speichern der Standard-Ansichten',
      },
    },
  },
})
